import { useMemo } from "react";

export const useMonthDates = (viewingDate: Date) => {
  const start = useMemo(() => {
    const date = new Date(viewingDate);
    date.setUTCDate(1);
    return date;
  }, [viewingDate]);

  const end = useMemo(() => {
    const date = new Date(viewingDate);
    date.setUTCMonth(date.getUTCMonth() + 1)
    date.setUTCDate(0);
    return date;
  }, [viewingDate]);

  return { start, end };
};